import React from "react";
import ProfileFormMain from "../../../shared/ProfileForm/ProfileFormMain";

function ProfileFormDetails(props) {
  return <ProfileFormMain></ProfileFormMain>;
}

export default ProfileFormDetails;
